import React from 'react'
import TabButtonGroupBase from './TabButtonGroupBase'
import type { TabButtonGroupBaseProps } from './TabButtonGroupBase'
import { TabButton } from './styles'
import { Box, useMediaQuery, useTheme } from '@mui/material'

export interface TabButtonOption {
  onChange: (() => void) | (() => Promise<void>)
  label?: string
  id: string
  disabled?: boolean
  dataQa?: string
}

export interface TabButtonGroupProps {
  options: TabButtonOption[]
  active?: number
  disabled?: boolean
  fullWidth?: boolean
  width?: string
}

const TabButtonGroup: React.FC<TabButtonGroupProps> = ({ options, active, disabled = false, fullWidth = false, width }) => {
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box width={fullWidth || downMd ? '100%' : width || 'auto'}>
      <TabButtonGroupBase tabIndex={active} disabled={disabled}>
        {
          options.map(option => (
            <TabButton key={option.id} onClick={() => option.onChange()} isDisabled={option.disabled} data-qa={option.dataQa}>
              {option.label}
            </TabButton>
          )) as TabButtonGroupBaseProps['children']
        }
      </TabButtonGroupBase>
    </Box>
  )
}

export default TabButtonGroup
